import { ActionTree } from 'vuex';
import axios from 'axios';
import { RootState } from '@/store/types';
import { ManagementTemplatesItem, ManagementTemplatesState } from './types';

export const actions: ActionTree<ManagementTemplatesState, RootState> = {
  getManagementTemplates: ({ commit }, data) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({ url: '/acapi/mail_notify/mn-templates', params: data })
        .then(resp => {
          commit('setManagementTemplates', resp.data);
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
        .finally(() => commit('setLoading', false));
    })
  },
  getManagementTemplatesItem: ({ commit }, id) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({ url: `/acapi/mail_notify/mn-templates/`, params: {id:id} })
        .then((resp: any) => {
          let messageTypeItem = <ManagementTemplatesItem>resp.data[0];
          messageTypeItem.id = id;
          commit('setManagementTemplatesItem', messageTypeItem);
          resolve(messageTypeItem)
        })
        .catch(err => {
          reject(err)
        })
        .finally(() => commit('setLoading', false));
    })
  },
  saveManagementTemplatesItem: ({ commit, dispatch }, data: ManagementTemplatesItem) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({
        method: data.id ? 'put' : 'post',
        url: '/acapi/mail_notify/mn-templates/' + (data.id ?? ''),
        data: data
      })
        .then((resp: any) => {
          dispatch('getManagementTemplates');
          resolve(resp)
        })
        .catch((err: any) => {
          reject(err)
        })
        .finally(() => commit('setLoading', false));
    })
  },
  deleteManagementTemplatesItem: ({ commit, dispatch }, data: ManagementTemplatesItem) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({
        method: 'delete',
        url: `/acapi/mail_notify/mn-templates/${data.id}`,
        data: data
      })
        .then((resp: any) => {
          dispatch('getManagementTemplates');
          resolve(resp)
        })
        .catch((err: any) => {
          reject(err)
        })
        .finally(() => commit('setLoading', false));
    })
  },
};
